import React from 'react';
import { Box } from '@rebass/grid';
import { Divider, Typography } from '@material-ui/core';
import SlidePage from '../organisim/slide-page';
import PostAuthor from './post-author';
import PostContent from './post-content';

const PostReadSheet = ({ open, onClose, post }) => {
  const safePost = post || {};
  const author =
    safePost.author_name || safePost.author?.name || safePost.created_by_name || 'Gym staff';
  const createdAt = safePost.created_at || safePost.createdAt;

  return (
    <SlidePage open={open} onClose={onClose} title="Feed">
      <PostAuthor authorId={safePost.author_id} fallbackName={author} createdAt={createdAt} />
      <Box mt="12px">
        <Typography variant="h6">{safePost.title || 'Update'}</Typography>
      </Box>
      <Divider style={{ margin: '16px 0' }} />
      <PostContent post={safePost} />
    </SlidePage>
  );
};

export default PostReadSheet;
